import { useLayoutEffect, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Resets scroll position on route changes while preserving in-page hash navigation.
 */
export function ScrollManager(): null {
  const location = useLocation();
  const { pathname, hash, search, key } = location;

  useLayoutEffect(() => {
    if (hash) return;
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname, search, key, hash]);

  useEffect(() => {
    if (!hash) return;
    const targetId = hash.slice(1);
    if (!targetId) return;

    let cancelled = false;

    const scrollToHash = () => {
      if (cancelled) return;
      const targetElement = document.getElementById(targetId);
      if (targetElement) {
        targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
      requestAnimationFrame(scrollToHash);
    };

    scrollToHash();

    return () => {
      cancelled = true;
    };
  }, [hash, pathname, search, key]);

  return null;
}

export default ScrollManager;
